import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/main/Login'
import Recover from '@/components/main/Recover'
import Devices from '@/components/main/Devices'
import DataSensor from '@/components/main/DataSensor'
import DataSound from '@/components/main/DataSound'
import DataResume from '@/components/main/DataResume'
import DataCompare from '@/components/main/DataCompare'
import DataDownload from '@/components/main/DataDownload'
import DataDashboard from '@/components/main/DataDashboard'
import DataMap from '@/components/main/DataMap'
import DeviceConfig from '@/components/main/DeviceConfig'
import Users from '@/components/main/Users'
import CreateUser from '@/components/main/CreateUser'
import Operation from '@/components/main/Operation'
import AnnotationTag from '@/components/main/AnnotationTag'
import Projects from '@/components/main/Projects'
import RecoverPass from '@/components/main/RecoverPass'
import ProjectImport from '@/components/main/ProjectImport'
import DataProjects from '@/components/main/DataProjects'
import { store } from '../store'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/login',
            component: Login
        },
        {
            path: '/recover',
            component: Recover
        },
        {
            path: '/devices',
            name: 'Dispositivos',
            component: Devices
        },
        {
            path: '/',
            name: 'Mapa',
            component: DataMap
        },
        {
            path: '/dashboard',
            name: 'Dash Board',
            component: DataDashboard
        },
        {
            path: '/sensor/:id',
            name: 'Datos Sensores',
            component: DataSensor
        },
        {
            path: '/laeq/:id',
            name: 'Datos Sensores Sonidos',
            component: DataSound
        },
        {
            path: '/resume',
            name: 'Resumen Mensual ',
            component: DataResume
        },
        {
            path: '/compare',
            name: 'Comparacion de datos',
            component: DataCompare
        },
        {
            path: '/downloads',
            name: 'Descargas',
            component: DataDownload
        },
        {
            path: '/deviceConfig',
            name: 'Configuracion dispositivos',
            component: DeviceConfig
        },
        {
            path: '/users',
            name: 'Configuracion usuarios',
            component: Users
        },
        {
            path: '/users/create',
            name: 'creacion usuarios',
            component: CreateUser
        },
        {
            path: '/users/recover',
            name: 'Recuperacion contrasena',
            component: RecoverPass
        },
        {
            path: '/operation',
            name: 'Agregar operaciones',
            component: Operation
        },
        {
            path: '/annotation',
            name: 'Anotacion',
            component: AnnotationTag
        },
        {
            path: '/projects',
            name: 'Redes Continuas',
            component: Projects
        },
        {
            path: '/projects/import',
            name: 'Crear Proyectos',
            component: ProjectImport
        },
        {
            path: '/projects/view',
            name: 'Ver Proyectos',
            component: DataProjects
        },

    ],
    mode: 'history'
})

let stepBylogin = false
let isInitialize = false

router.beforeEach((to, from, next) => {
    const publicPages = ['/login', '/users/create', '/recover', '/users/recover']
    const authRequired = !publicPages.includes(to.path)
    const user = JSON.parse(localStorage.getItem('user'))
    
    if (!authRequired) {
        next()
        return
    }

    if (to.path === '/login')
        stepBylogin = true
    
    if (user !== null) {
        if (!stepBylogin && !user.remember)
            store.dispatch('logout')
    }
    
    let loggedIn = localStorage.getItem('user')
    let isPreview = false
    let isMaintainer = false   
    let isDev = false   

    if (user !== null) {
        isPreview = user.roles.some( e => {
            return e.name === "preview"
        })

        isMaintainer = user.roles.some( e => {
            return e.name === "maintainer"
        })

        isDev = user.roles.some( e => e.name === "dev")
    }
    
    if (!isInitialize) {
        isInitialize = true
        store.dispatch('pullDevices')
        store.dispatch('pullSensors')
        store.dispatch('pullAllSensors')
        store.dispatch('pullInfoDevices')
        store.dispatch('pullProjects')
        
        if (isDev)
            store.dispatch('pullProjectTest')
            
        setInterval (() => {
            store.dispatch('pullInfoDevices')
        }, 5 * 60 * 1000)
    }
    
    if (to.path === '/' && isPreview)
        next('/devices')

    if (authRequired && !loggedIn) {
        next('/login')
    } else {
        next()
    }
})

export default router